import React from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';

const SystemMessages: React.FC = () => {
  return (
    <DashboardLayout>
      <div className="p-4">
        <div className="card bg-white rounded-sm p-4 border border-slate-300">
          <h2 className="text-lg font-bold text-slate-800 mb-4">پیام‌های سیستم</h2>
          <p className="text-slate-600 mb-4">
            در این بخش می‌توانید پیام‌های سیستم را مشاهده کنید.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SystemMessages;
